angular.module('env', [
    'env.log',
    'env.exceptions',
    'env.helpers',
    'templates',
    'env.templateResolver',
    'env.loading',
    'env.localStorage',
    'env.notifications',
    'env.uiRouter',
    'env.userSettings',
    'env.events',
    'env.context',
    'env.device',

    'env.data',
    'env.i18n',
    'env.custom'
]);